<template>
  <v-dialog v-model="dialog" width="460">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" text class="change-password-trigger">
        <v-icon left size="18">mdi-lock-reset</v-icon>Change password
      </v-btn>
    </template>

    <v-card class="change-password-card" elevation="12">
      <div class="change-password-header">
        <div class="change-password-icon"><v-icon color="primary">mdi-lock-reset</v-icon></div>
        <div>
          <div class="change-password-eyebrow">Account security</div>
          <h2>Change password</h2>
          <p>{{ dialogDescription }}</p>
        </div>
        <v-btn icon aria-label="Close" class="change-password-close" @click="close">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="change-password-body">
        <v-text-field
          v-model="newPassword"
          :append-icon="showNewPassword ? 'visibility_off' : 'visibility'"
          :type="showNewPassword ? 'text' : 'password'"
          label="New Password"
          :error-messages="newPasswordErrors"
          outlined
          dense
          counter
          autofocus
          @click:append="showNewPassword = !showNewPassword"
          @keyup.enter="update"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions class="change-password-actions">
        <v-btn text @click="close">Cancel</v-btn>
        <v-spacer />
        <v-btn color="primary" depressed :loading="loading" @click="update">Update password</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import userService from "../service";
import { mapGetters } from "vuex";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  props: ["UserId"],
  data() {
    return {
      showNewPassword: false,
      dialog: false,
      loading: false,
      User: null,
      newPassword: null
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getUser();
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    newPassword: {
      required,
      minLength: minLength(4)
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    isOwnPassword() {
      return Number(this.UserId) === Number(this.currentUser.id);
    },
    dialogDescription() {
      return this.isOwnPassword
        ? "Choose a new password for your account."
        : `Choose a new password for ${this.User ? this.User.name : "this user"}.`;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) return errors;
      if (!this.$v.newPassword.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.newPassword.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    }
  },
  methods: {
    close() {
      this.User = null;
      this.newPassword = null;
      this.showNewPassword = false;
      this.loading = false;
      this.$v.$reset();
      this.dialog = false;
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.loading = true;
        return userService
          .changePassword(this.UserId, {
            newPassword: this.newPassword
          })
          .then(result => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  icon: "success",
                  title: "Password Change!"
                });
              this.close();
              if (this.isOwnPassword) this.$router.push("/logout");
            }
          })
          .catch(err => {
            console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                icon: "error",
                title: err.data.message
              });
          });
      }
    },
    getUser() {
      return userService.getById(this.UserId).then(response => {
        this.User = response.data;
      });
    }
  }
};
</script>

<style scoped>
.change-password-trigger { text-transform: none; letter-spacing: 0; }
.change-password-card { overflow: hidden; border: 1px solid #e3e9e3; border-radius: 13px !important; }
.change-password-header { position: relative; display: flex; gap: 13px; padding: 22px 52px 18px 22px; background: #f7faf7; }
.change-password-icon { display: flex; width: 42px; height: 42px; flex: 0 0 42px; align-items: center; justify-content: center; border-radius: 10px; background: #eaf6eb; }
.change-password-eyebrow { color: #43a047; font-size: 10px; font-weight: 750; letter-spacing: .1em; text-transform: uppercase; }
.change-password-header h2 { margin: 2px 0 3px; color: #172033; font-size: 20px; line-height: 1.25; }
.change-password-header p { margin: 0; color: #728095; font-size: 12px; }
.change-password-close { position: absolute; top: 12px; right: 12px; }
.change-password-body { padding: 24px 22px 10px !important; }
.change-password-body >>> .v-input__slot { border-radius: 8px; }
.change-password-actions { padding: 12px 18px; }
.change-password-actions .v-btn { border-radius: 8px; text-transform: none; letter-spacing: 0; }
</style>
